import { CatalogCard } from "../components/CatalogCard";
import { SortedCatalog } from "../components/SortedCatalog";
import { competitionDefinitions } from "./competitionDefinitions";

export function CompetitionCatalog({ limit }: { limit?: number }) {
  return (
    <SortedCatalog
      items={competitionDefinitions}
      label="Sort Competitions"
      limit={limit}
      renderItem={(item) => (
        <CatalogCard
          key={item.name}
          title={item.title}
          heading={limit ? "h3" : "h2"}
          description={item.description}
          image={item.image}
          tags={item.tags}
          to={`/competitions/${item.name}`}
          testId={`competition-card-${item.name}`}
        />
      )}
    />
  );
}
